import React from 'react';

const NAV_ITEMS = [
  { label: 'Gurbani.io', href: 'https://gurbani.io/' },
];

const Sidebar = () => (
  <nav aria-label="Site navigation" className="sidebar">
    <ul>
      {NAV_ITEMS.map(item => (
        <li key={item.href}>
          <a href={item.href} target="_blank" rel="noopener noreferrer">
            {item.label}
            <span className="sr-only"> (opens in new tab)</span>
          </a>
        </li>
      ))}
    </ul>
  </nav>
);

export default Sidebar;
